import { roundResolutionValues } from '../utilities/round';
import { Resolution } from '../utilities/types';
import { CalculatorOutputProps } from './types';

interface ProcessProps {
  outputAspectRatio: number;
  lensSqueezeFactor: number;
  safetyCrop: number;
}

const amountOfPixels = 8297000;

export const calculateWorkingResolution = (
  props: ProcessProps
): CalculatorOutputProps => {
  const normalizedSafetyCrop = (100 - props.safetyCrop) / 100;
  const divided = props.outputAspectRatio / props.lensSqueezeFactor;
  const multiplied = props.outputAspectRatio * props.lensSqueezeFactor;
  const width = Math.sqrt(amountOfPixels / (divided * 1)) * divided;
  const height =
    Math.sqrt(amountOfPixels / multiplied) * props.lensSqueezeFactor;

  const minimumResolutionRaw: Resolution = { width, height };
  const minimumCapturedResolutionRaw: Resolution = {
    width: width / normalizedSafetyCrop,
    height: height / normalizedSafetyCrop,
  };

  return {
    minimumActiveImageResolution: roundResolutionValues(minimumResolutionRaw),
    minimumCapturedResolution: roundResolutionValues(
      minimumCapturedResolutionRaw
    ),
  };
};
